<template>
  <!-- 手动选车型 -->
  <div class="model">
    <el-dialog
      title="选择车型"
      width="820px"
      :visible.sync="dialogVisible"
      center
      :close-on-click-modal="false"
    >
      <div v-show="step">
        <div class="brand-tit">按品牌首字母选择：</div>
        <el-row class="strlist" type="flex" justify="space-between">
          <div
            v-for="(strlist, index) in initial"
            class="initial"
            :key="index"
            :class="{ active: intIndex == index }"
            @click="getChooseBrand(index, strlist)"
          >
            {{ strlist }}
          </div>
        </el-row>
        <div class="brands-con">
          <div class="brandsList">
            <div
              :span="4"
              v-for="(brand, index) in brands"
              :key="index"
              class="lists"
              @click="getCarSerial(brand.element.brand, brand.symbol)"
            >
              <img :src="brand.element.logo" class="image" />
              <div class="brand" :title="brand.element.brand">
                {{ brand.element.brand }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!step">
        <div class="tag-box">
          已选：
          <el-tag
            effect="plain"
            size="medium"
            :key="index"
            v-for="(tag, index) in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag, index)"
            class="tag"
          >
            {{ tag.name }}
          </el-tag>
        </div>
        <div class="factory-box" v-if="stepSub == 1">
          <div v-for="(type, index) in carSerialList" :key="index">
            <div class="factory-subTit">{{ type.key }}</div>
            <div class="type">
              <div
                class="norms"
                v-for="(cname, index) in type.value"
                :class="{ disactive: disIndex == index }"
                :key="index"
                @click="
                  getCarTypeInfo(cname.element[0].value, cname.symbol, index)
                "
                :title="cname.element[0].value"
              >
                {{ cname.element[0].value }}
              </div>
            </div>
          </div>
        </div>
        <div class="factory-box" v-if="stepSub == 2">
          <div class="type">
            <div
              class="norms"
              v-for="(carType, index) in carTypeList"
              :class="{ disactive: disIndex == index }"
              :key="index"
              @click="
                getCarTypeInfo(filterValue(carType), carType.symbol, index)
              "
              :title="filterValue(carType)"
            >
              {{ filterValue(carType) }}
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :disabled="confirmDis"
          @click="confirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCarType } from "@/api/service/catalog";
export default {
  data() {
    return {
      dynamicTags: [],

      /** 对话框的显示隐藏 */
      dialogVisible: false,

      confirmDis: true, //确认按钮的点击状态
      step: true,
      stepSub: 1,

      initial: [], //首字母列表

      abbr: "A", //当前选择的首字母
      brandName: "", //当前选择的品牌名
      carMake: "", //当前选择厂牌名
      carSerial: "", //当前选择系列
      carYear: "", //当前选择年份
      displacement: "", //当前选择排量

      carTypeInfoSymbol: "", //车型Symbol

      carTypeInfoId: "", //最后选择的车型ID

      carTypeList: "", //车型号

      brands: [], // 车的品牌列表

      carSerialList: [], //车系列

      carYearList: [], //车年份

      carDisplacementlist: [], //车排量

      carModelName: "", //车型

      //选择的字母的index
      intIndex: 0,

      disIndex: -1,

      //选择车型的index
      cartypeIndex: ""
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getInitial();
        this.getChooseBrand(0, "A");
      } else {
        this.step = true;
        this.stepSub = 1;
        this.intIndex = 0;
        this.disIndex = -1;
        this.carTypeInfoSymbol = "";
        this.dynamicTags = [];
        this.carModelName = "";
        this.confirmDis = true;
      }
    }
  },
  methods: {
    /** 获取首字母列表 */
    getInitial() {
      // this.axios.get("/carType").then(response => {
      getCarType().then(response => {
        this.initial = response.data.data.list;
      });
    },

    /** 根据首字母获取车的品牌 */
    getChooseBrand(index, strlist) {
      this.abbr = strlist;
      /* this.axios
        .get("/carType", { params: { abbr: strlist } })
        .then(response => { */
      getCarType({ abbr: strlist }).then(response => {
        if (response.data.status == 0) {
          this.intIndex = index;
          this.brands = response.data.data.list;
        }
      });
    },

    /** value显示 element拼接字符串 过滤掉图片链接 */
    filterValue(list) {
      let value = "";
      let reg = /.*\.(jpg|jpeg|gif|png|bmp|svg|webp)(\?.*)?/i;
      for (let i in list.element) {
        if (list.element[i].value && list.element[i].value.match(reg)) {
          value = "";
        } else {
          value = value + list.element[i].value;
        }
      }
      return value;
    },

    getCarTypeInfo(name, symbol, index) {
      // this.axios.get("/carType", { params: { symbol: symbol } }).then(res => {
      getCarType({ symbol: symbol }).then(res => {
        if (res.data.status == 0) {
          if (res.data.data.view == "carTypeInfo") {
            this.disIndex = index;
            this.confirmDis = false;
            // this.carModelName = res.data.data.list.element.modelCname
            if (this.dynamicTags.length < 2) {
              this.carModelName = this.dynamicTags[0].name;
            } else {
              this.carModelName = `${this.dynamicTags[0].name} ${this.dynamicTags[1].name}`;
            }
            this.carTypeInfoSymbol = res.data.data.list.symbol;
          } else {
            let oldSymbol = this.dynamicTags.find(emit => {
              return emit.symbol == symbol;
            });
            if (!oldSymbol) {
              this.dynamicTags.push({ name: name, symbol: symbol });
            }
            this.stepSub = 2;
            this.carTypeList = res.data.data.list;
          }
        }
      });
    },

    /** 根据选择的品牌获取车系列 */
    getCarSerial(brandName, symbol) {
      this.step = false;
      this.stepSub = 1;
      this.dynamicTags.push({ name: brandName });
      this.carSerialList = [];
      this.brandName = brandName;
      // this.axios.get("/carType", { params: { symbol: symbol } }).then(res => {
      getCarType({ symbol: symbol }).then(res => {
        if (res.data.status == 0) {
          this.carSerialList = res.data.data.list;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    /** 关闭标签 */
    handleClose(tag, index) {
      this.confirmDis = true;
      this.carTypeInfoId = "";
      this.disIndex = -1;
      this.dynamicTags.splice(index, this.dynamicTags.length - index);
      length = this.dynamicTags.length;
      if (this.dynamicTags.length == 0) {
        this.step = true;
        this.dynamicTags = [];
      } else if (this.dynamicTags.length == 1) {
        this.stepSub = 1;
      } else {
        this.getCarTypeInfo(
          this.dynamicTags[length - 1].name,
          this.dynamicTags[length - 1].symbol
        );
      }
    },

    /** 确认 */
    confirm() {
      this.$emit("confirm", [this.carTypeInfoSymbol, this.carModelName]);
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/custom.scss";

.initial {
  width: 26px;
  height: 26px;
  border: 1px solid #ccc;
  font-size: 14px;
  text-align: center;
  line-height: 26px;
  &:hover {
    color: $main-color;
    border: 1px solid $main-color;
    cursor: pointer;
  }
}

.active {
  background-color: $main-color;
  border: 1px solid $main-color;
  color: $white-color;
  &:hover {
    color: $white-color;
  }
}
.strlist {
  margin-bottom: 20px;
  margin-right: 25px;
}
.brands-con {
  height: 210px;
  overflow-y: auto;
}
.brandsList {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.lists {
  width: 155px;
  margin-bottom: 15px;
  margin-right: 12px;
  padding: 5px 10px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;

  .image {
    max-width: 100%;
    max-height: 100%;
  }
  .brand {
    width: 155px;
    height: 38px;
    text-align: center;
    font-size: 14px;
    line-height: 38px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &:hover {
    color: $main-color;
    border: 1px solid $main-color;
    cursor: pointer;
  }
}
.brand-tit {
  width: 100%;
  line-height: 14px;
  font-size: 14px;
  color: #5a5a5a;
  text-align: left;
  font-weight: bold;
  padding-bottom: 15px;
}

.tag-box {
  width: 100%;
  height: auto;
  margin-bottom: 5px;
  border-bottom: 1px solid #f2f2f2;
}
.factory-box {
  width: 100%;
  height: 257px;
  border-bottom: 1px solid #f2f2f2;
  overflow-y: auto;
  overflow-x: hidden;
}
.factory-subTit {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #5a5a5a;
  text-align: left;
  padding-left: 10px;
  margin: 12px 0;
  border-left: 2px solid $main-color;
}
.type {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .norms {
    width: 175px;
    height: 26px;
    margin: 5px 5px;
    padding: 0 4px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 26px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;

    &:hover {
      color: $main-color;
      border: 1px solid $main-color;
      cursor: pointer;
    }
  }
  .disactive {
    border: 1px solid $main-color;
    color: $main-color;
  }
}
.cartype-ul {
  margin: 5px;
  li {
    color: #777777;
    line-height: 30px;
    &:hover {
      cursor: pointer;
      color: $main-color;
    }
  }
  .ctyactive {
    color: $main-color;
  }
}

.tag {
  margin: 0 8px;
  margin-bottom: 10px;
}
</style>

<style scoped>
.model >>> .el-dialog {
  min-width: 650px;
}
.model >>> .el-dialog__body {
  padding: 10px 20px;
}
</style>
